<template>
  <div class="ac2">
    <!-- banner -->
    <div class="banner">
      <img src="/imgs/b5.jpg" alt="" />
    </div>
    <!-- 顶宽布局 -->
    <div class="container">
      <!-- 标题 -->
      <div class="us-title">
        <p>关于我们</p>
        <span>About Us</span>
      </div>
      <!-- 容器 -->
      <div class="cont-flex">
        <!-- 右侧 介绍 -->
        <div class="us-info">
          <p>
            江苏淮田万顷农业科技有限公司由淮阴区农业总公司与万顷牛集团共同组建。淮阴区农业总公司是淮安农业全产业链服务平台与乡村振兴的主力军，万顷牛集团是国内领先的农业互联网平台。
          </p>
          <p>
            公司的愿景是成为淮安农产品领先的数字化供应链服务商，从而助力乡村振兴、服务区域经济
          </p>

          <p>公司的产品是淮田云协同供应链云，分布式服务于供应商、采购商与平台运营商：
            帮助供应商实现多渠道分发与结算系统
            帮助采购商实现协同供应链管理与结算系统
            帮助平台运营商实现自己的区域平台或垂直平台
            通过供应链云的基础服务，帮助他们互联互通，从而实现组织协同、流程协同与信息协同。
          </p>

          <!-- <p>智美理护为创造价值而生，专注美好生活服务供应商。</p> -->
        </div>
        <div class="us-img">
          <img src="/imgs/info2.jpg" alt="" />
        </div>
      </div>
      <!-- 文本区 -->
      <div class="a2-info" style="display: none">
        <!-- 使命 -->
        <div class="a2-item">
          <div class="title"><span>我们的使命</span></div>
          <p>生者悦之 | 疾者舒之 | 老者安之</p>
        </div>
        <!-- 愿景 -->
        <div class="a2-item">
          <div class="title"><span>我们的愿景</span></div>
          <p>为亿万中国家庭提供有价值的照护服务&健康服务</p>
          <p>为千万照护服务&健康服务人才提供价值实现的服务</p>
        </div>
        <!-- 价值观 -->
        <div class="a2-item">
          <div class="title"><span>我们的价值观</span></div>
          <p>朴素、尊重、责任、同理、专注、专业、创新、极致</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/css/swiper.css";

export default {
  name: "ac1",
  components: {},
  data() {
    return {};
  },
  mounted() {
    document.title = "江苏淮田万顷农业科技有限公司";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac2 {

  //   margin-top: 60px;
  .banner {
    width: 100%;
    // height: auto;
    height: 400px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .container {
    // height: 1000px;
    margin: 0 auto;
    padding-top: 30px;
    box-sizing: border-box;

    // 标题
    .us-title {
      width: 314px;
      border-bottom: 2px solid #bbbbbb;
      font-size: 24px;
      line-height: 30px;
      margin: 0 auto 60px;

      p {
        position: relative;
        display: inline-block;
        font-weight: 700;

        &::after {
          position: absolute;
          content: " ";
          width: 100%;
          bottom: -8px;
          left: 0;
          border-bottom: 5px solid #bbbbbb;
        }
      }

      span {
        font-size: 18px;
        margin-left: 10px;
      }
    }

    // 容器
    .cont-flex {
      display: flex;
      border: 1px solid #eeeeee;
    }

    .us-img {
      padding: 8px;

      img {
        width: 470px;
        height: 410px;
        // margin: 30px auto;
      }
    }

    // 右侧 信息
    .us-info {
      flex: 1;
      padding: 20px;
      text-indent: 24px;

      p {
        font-size: 14px;
        line-height: 50px;
        margin: 20px 0;
      }
    }

    // 文本区
    .a2-info {
      padding-top: 50px;

      .a2-item {
        .title {
          border-bottom: 1px solid #f0f0f0;
          margin-bottom: 20px;
          margin-top: 20px;

          span {
            background: #f0f0f0;
            display: inline-block;
            width: 182px;
            font-size: 18px;
            line-height: 40px;
            text-indent: 30px;
          }
        }

        p {
          font-size: 14px;
          line-height: 30px;
        }
      }
    }
  }
}</style>
